// Shared by the Eventbrite and PheedLoop panels: read an upload, save a download.
export interface UploadFile {
  name: string;
  content: string;
}

export const UPLOAD_ACCEPT = '.csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function readUpload(f: File): Promise<UploadFile> {
  if (/\.(xls|numbers)$/i.test(f.name))
    throw new Error('Save the file as .xlsx or .csv (File → Save As), then upload it.');
  if (!/\.(csv|xlsx)$/i.test(f.name)) throw new Error('Upload a .csv or .xlsx file.');
  if (/\.csv$/i.test(f.name)) return { name: f.name, content: await f.text() };
  const bytes = new Uint8Array(await f.arrayBuffer());
  let binary = '';
  for (let i = 0; i < bytes.length; i += 0x8000) binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return { name: f.name, content: btoa(binary) };
}

export function saveText(fileName: string, text: string, type = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const stamp = (iso: string | null | undefined) =>
  iso
    ? new Date(iso).toLocaleString('en-CA', { timeZone: 'America/Toronto', dateStyle: 'medium', timeStyle: 'short' })
    : 'never';
